import {
  base_colorAction,
  base_colorAlert,
  base_colorContentBorder,
  base_colorSurfaceSecondary,
  text_colorTextPrimary,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import {
  font_family_weight_medium,
  font_family_weight_regular,
  font_lg,
  font_md,
  font_sm,
  fontH2,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  &.SanctionedScreeningForm {
    position: relative;
    display: flex;
    flex-direction: column;
    gap: ${spacing(5)};

    .screening-page {
      display: flex;
      flex-direction: column;
      gap: ${spacing(5)};
    }
  }

  .screening-header {
    ${fontH2}
    color: ${text_colorTextPrimary};
  }

  .screening-description {
    font-family: ${font_family_weight_regular};
    ${font_lg}
    color: ${text_colorTextSecondary};

    strong {
      font-family: ${font_family_weight_medium};
      font-weight: normal;
    }
  }

  .screening-image-container {
    position: absolute;
    top: -60px;
    right: -60px;
    overflow: hidden;
    border-radius: 10px;
    height: 200px;
    width: 200px;
  }

  .screening-image {
    transform: scale(1.7) rotate(-20deg);
    position: absolute;
    top: -10px;
    right: -15px;
  }

  .form-fields {
    display: flex;
    flex-direction: column;
    gap: ${spacing(5)};
  }

  .form-bottom {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-top: ${spacing(5)};
  }

  .back-link {
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;
    color: ${base_colorAction};
    background: none;
    border: none;
    padding: 0;
    font-family: ${font_family_weight_medium};
    ${font_md}
  }

  .info-safe {
    display: flex;
    flex-direction: row;
    gap: ${spacing(2)};
    align-items: center;
    margin-top: ${spacing(5)};
  }

  .info-safe-text {
    font-family: ${font_family_weight_regular};
    ${font_sm}
    color: ${text_colorTextSecondary};
  }

  .review-box {
    padding: ${spacing(10)};
    display: flex;
    flex-direction: column;
    border-radius: 10px;
    background: ${base_colorSurfaceSecondary};
    border: 1px solid ${base_colorContentBorder};
  }

  .review-box-top {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .review-box-title {
    font-family: ${font_family_weight_medium};
    ${font_lg}
    color: ${text_colorTextPrimary};
  }

  .review-box-content {
    font-family: ${font_family_weight_regular};
    ${font_md}
    color: ${text_colorTextSecondary};
    white-space: pre-line;
    margin-top: ${spacing(3)};
  }

  .update-link {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: ${spacing(1)};
    cursor: pointer;
    color: ${base_colorAction};
    background: none;
    border: none;
    padding: 0;
    font-family: ${font_family_weight_medium};
    ${font_md}
  }

  .review-disclaimer {
    font-family: ${font_family_weight_regular};
    ${font_sm}
    color: ${text_colorTextSecondary};
  }

  .top-level-error {
    color: ${base_colorAlert};
    font-family: ${font_family_weight_regular};
    ${font_md}
  }
`
